module.exports = __webpack_public_path__ + "static/media/listo.2640de7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/listo.png
// module id = 254
// module chunks = 0